import { IApiManagement, IApiManagementDto } from "@kuika/kuika-cl-model";
import { AxiosResponse } from "axios";
import { ApiManagementService } from "./api-management-service";

// KOA-18175: whether the preview flow should open the generated app's Swagger
// tab must not depend on the designer's in-memory project state. That state is
// hydrated lazily (only when the API Builder section is opened) and the
// apiManagements snapshot inside project.json is deliberately excluded from
// project meta patches (KOA-11322), so after a fresh designer load it can claim
// "no APIs" for a project that has them — or the reverse after all APIs were
// deleted. The server's KApiManagement table is the source of truth, so ask it;
// the lazily-loaded local list is only a fallback for when the request fails.
export async function shouldOpenSwaggerPreviewTab(
  projectId: string | undefined,
  localApiManagements: IApiManagement[] | undefined
): Promise<boolean> {
  const hasLocalApis: boolean = Boolean(localApiManagements && localApiManagements.length > 0);
  if (!projectId) {
    return hasLocalApis;
  }

  try {
    const res: AxiosResponse<IApiManagementDto[]> = await ApiManagementService.GetAllByProjectId(projectId);
    // GetAllByProjectId swallows request errors and returns the error object,
    // so validate the shape instead of trusting the type.
    if (res && res.status === 200 && Array.isArray(res.data)) {
      return res.data.length > 0;
    }
  } catch {
    // Fall through to the local fallback below.
  }

  return hasLocalApis;
}
